import colors from '../../../constants/colors'
import styled from 'styled-components'
import Translator from '../helpers/Translator'

export default function AppFileUploader(props) {
  const {
    id = 0,
    value,
    isMulti = false,
    btnText,
    btnClass = 'btn-info',
    onChange,
    isDisabled = false,
    placeholder = '',
    error,
    containerClassName = '',
    required = false,
    ...others
  } = props

  return (
    <Container
      className={`${containerClassName}${isDisabled ? ' disabled' : ''}`}
      error={error}
      htmlFor={`upload-${id}`}
    >
      {/* <div className="file-uploader" style={required ? { border: '18px', color: '#325a6b', marginBottom: '20px' } : null}> style={required ? {''} : {}} */}
      <div className={`file-uploader${error ? ' error' : ''}`}>
        {placeholder ||
          (isMulti ? (
            <Translator
              file="module-legalCompliance"
              name="select.one.multiple.files"
            />
          ) : (
            <Translator file="general" name="select.a.file" />
          ))}
      </div>
      <input
        id={`upload-${id}`}
        type="file"
        style={{ display: 'none' }}
        onChange={(e) => onChange(e.target.files)}
        multiple={isMulti}
        disabled={isDisabled}
        {...others}
      />
      <div className="upload-btn">
        <label className={`m-0 btn ${isDisabled ? 'btn-secondary' : btnClass}`}>
          {btnText || <Translator file="general" name="search..." />}
        </label>
      </div>
    </Container>
  );
}

const Container = styled.label`
  position: relative;
  display: flex;
  width: 100%;
  background-color: white;
  margin: 10px 0;
  cursor: pointer;
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  border: ${(props) => (props.error ? colors.danger : '#ddd')} solid 1px;
  border-right: 0;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  .btn {
    border-radius: 0 !important;
  }
  .file-uploader {
    flex: 1 auto;
    padding: 4px 10px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    pointer-events: none;
    color: #aaa;
    line-height: 1.8;
    &.error {
        border-color: ${colors.danger};
    }
  }
  .upload-btn {
    label {
      pointer-events: none;
      z-index: 0;
      &.btn {
        padding: 4px 10px;
      }
    }
  }
`
